import { createBrowserRouter } from "react-router-dom";
import ErrorPage from "../../error-page";
import Login from "./Auth/Login";
import RequireAuth from "./Auth/RequireAuth";
import Layout from "./Layout";
import { AuthProvider } from "./Auth/AuthContext";
import ErrorTest from "./ErrorTest";
import NotFound from "./NotFound";

const router = createBrowserRouter([
  {
    path: "/",
    element: <AuthProvider><Layout /></AuthProvider>,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Login />,
      },
      {
        path: "error-test",
        element: <ErrorTest />,
      },
      {
        element: <RequireAuth />,
        children: [
          {
            path: "dashboard",
            lazy: () => import("./Dashboard").then(m => ({ Component: m.default })),
          },
          {
            path: "declaration/new",
            lazy: () => import("./Declaration").then(m => ({ Component: m.Declaration })),
          },
          {
            path: "declaration/:id",
            lazy: () => import("./DeclarationRouter").then(m => ({ Component: m.default })),
          },
          {
            path: "declaration/v1/:id",
            lazy: () => import("./DeclarationDetailV1").then(m => ({ Component: m.default })),
          },
          {
            path: "declaration/:id/:interventionId",
            lazy: () => import("./DeclarationDetail").then(m => ({ Component: m.default })),
          },
          {
            path: "declaration/:id/:interventionId/confirmation",
            lazy: () => import("./DeclarationConfirmation").then(m => ({ Component: m.default })),
          },
        ],
      },
    ],
  },

  {
    path: '*',
    element: <NotFound />,
  }
]);

export default router;